import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export function initProgressBar() {
	document.querySelectorAll('.full-section__progress-gauge > div').forEach(bar => {
		const targetValue = parseInt(bar.dataset.value, 10);

		bar.style.width = "0%"; // reset avant animation

		gsap.to(bar, {
			width: targetValue + "%",
			duration: 1,
			ease: "power2.out",
			scrollTrigger: {
				trigger: bar.parentElement,
				start: "top 95%",
				// toggleActions: "play none none none",
				once: true,
				// invalidateOnRefresh: true
			},
			onComplete: () => { bar.classList.add("show-value"); },
			onReverseComplete: () => { bar.classList.remove("show-value"); }
		});
	});
}